import { render, staticRenderFns } from "./BolBackButton.vue?vue&type=template&id=0d412f05&scoped=true"
import script from "./BolBackButton.vue?vue&type=script&lang=js"
export * from "./BolBackButton.vue?vue&type=script&lang=js"
import style0 from "./BolBackButton.vue?vue&type=style&index=0&id=0d412f05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d412f05",
  null
  
)

export default component.exports